import { render, staticRenderFns } from "./OcrPdf.vue?vue&type=template&id=03f73936&scoped=true"
import script from "./OcrPdf.vue?vue&type=script&lang=js"
export * from "./OcrPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f73936",
  null
  
)

export default component.exports